import { atom } from 'jotai';

export interface LoadingProgressState {
  activeImages: Set<number>;
  enabledImages: Set<number>;
  progress: number;
}

const defaultState: LoadingProgressState = {
  activeImages: new Set<number>(),
  enabledImages: new Set<number>(),
  progress: 0,
};

export const loadingProgressAtom = atom<LoadingProgressState>(defaultState);

// Derived atoms for individual values
export const activeImagesAtom = atom(
  (get) => get(loadingProgressAtom).activeImages,
  (get, set, newActiveImages: Set<number>) =>
    set(loadingProgressAtom, {
      ...get(loadingProgressAtom),
      activeImages: newActiveImages,
    }),
);

export const enabledImagesAtom = atom(
  (get) => get(loadingProgressAtom).enabledImages,
  (get, set, newEnabledImages: Set<number>) =>
    set(loadingProgressAtom, {
      ...get(loadingProgressAtom),
      enabledImages: newEnabledImages,
    }),
);

export const progressAtom = atom(
  (get) => get(loadingProgressAtom).progress,
  (get, set, newProgress: number) =>
    set(loadingProgressAtom, {
      ...get(loadingProgressAtom),
      progress: newProgress,
    }),
);
